import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
// import { colorBackgroundBrightness } from 'data/common.data';
import '../ProductType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Checkin = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    // const headerBg: string = '/images/backgrounds/ALEG-Image-Industry_Header.jpg'
    // const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    const contentData: string = 'With automated check-in air travelers can save time and travel stress free. AI-powered digital assistant will check them in, getting boarding passes delivered to their mobile phone with all necessary details.';
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit | Product | Auto Check-in</title>
                    <meta name='description' content={contentData} />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height product-type-data-container'>
                <div className='header-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <div className='product-logo-wrapper'>
                                        <img src='/images/icons/ALEG-ID-AutoCheckIn.png' alt='Auto Check-in' />
                                    </div>
                                    <p className='no-margin'>
                                        Streamline air travel with automated check-in to deliver a host of valuable features and convenience for your passengers.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='logo-wrapper' style={{ maxWidth: '350px' }}>
                                        <img src='/images/others/ALEG-Image-TextPhone_1.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='colored-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-12 text-med'>
                                    With traveler preferences for TSA Pre-check, seat assignment, frequent flyer number, and passport/identity documents, Automated Check-in improves the travel experience with smooth, transparent boarding pass delivery to your passenger's mobile device.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='feature-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='header-text-main'>
                                        Features
                                    </div>
                                    <div className='separator'></div>
                                </div>
                                <div className='col-md-8 order-1 order-md-2 small-screen-padding-top'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='header-text text-l2 text-med'>
                                                24/7 AVAILABILITY CONVENIENT
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Automated check-in is available around the clock for at any time check-in.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                CONVENIENT
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Passengers avoid lines and lengthy in-person check-in procedures.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top large-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                SEAMLESS
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Traveler information and preferences are stored far an optimal boarding experience.
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col-md-6 small-screen-padding-top large-screen-padding-top'>
                                            <div className='header-text text-l2 text-med'>
                                                POSITIVE
                                            </div>
                                            <div className='content-text'>
                                                <p className='no-margin'>
                                                    Your travelers will avoid being waitlisted for the oversold flight.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer/>
        </>
    );
};

export default Checkin;